import React from 'react';
import { DensityMode } from '../../types/grid';
import { Menu, StretchHorizontal } from 'lucide-react';
import { Button } from '../ui/Button';

interface DensityToggleProps {
  density: DensityMode;
  onChange: (d: DensityMode) => void;
}

export const DensityToggle: React.FC<DensityToggleProps> = ({ density, onChange }) => {
  return (
    <div className="flex items-center h-7 rounded bg-cf-bg border border-cf-border overflow-hidden">
      <Button
        type="button"
        variant="ghost"
        size="xs"
        onClick={() => onChange('compact')}
        className={`h-full rounded-none px-2 text-xs transition-colors ${
          density === 'compact'
            ? 'bg-cf-surfaceHover text-cf-textPrimary font-medium'
            : 'text-cf-textSecondary hover:text-cf-textPrimary hover:bg-cf-surfaceHover'
        }`}
        icon={<Menu size={12} />}
        title="Compact density (34px row height)"
      >
        <span className="hidden sm:inline">Compact</span>
      </Button>

      <Button
        type="button"
        variant="ghost"
        size="xs"
        onClick={() => onChange('normal')}
        className={`h-full rounded-none px-2 text-xs transition-colors ${
          density === 'normal' || (density as any) === 'relaxed'
            ? 'bg-cf-surfaceHover text-cf-textPrimary font-medium'
            : 'text-cf-textSecondary hover:text-cf-textPrimary hover:bg-cf-surfaceHover'
        }`}
        icon={<StretchHorizontal size={12} />}
        title="Normal density (42px row height)"
      >
        <span className="hidden sm:inline">Normal</span>
      </Button>
    </div>
  );
};
